import { AST, Interpolation, InterpolationConfig, Lexer, LiteralPrimitive, Parser } from '@angular/compiler';
import { Injectable, Injector } from '@angular/core';
import _ from 'lodash';
import { AstVistor } from 'src/app/services/interpolation/visitor';
import { TranslatePipe } from '@ngx-translate/core';

type Context = unknown;

export class TextInterpolation {
	constructor(private ast: AST, private injector: Injector, private translatePipe: TranslatePipe) {
	}

	public interpolate(ctx: Context): string {
		return this.ast.visit(new AstVistor(this.injector, this.translatePipe), ctx);
	}
}

@Injectable({
	providedIn: 'root',
})
export class InterpolationService {
	private _parser: Parser;
	private _textInterpolations: Map<string, TextInterpolation>;

	constructor(private injector: Injector, private translatePipe: TranslatePipe) {
		this._parser = new Parser(new Lexer());
		this._textInterpolations = new Map<string, TextInterpolation>();
	}

	public interpolate(text: string, parameters: Context): string {
		if (_.isString(text)) {
			const textInterpolation = this.getTextInterpolation(text);
			if (textInterpolation) {
				text = textInterpolation.interpolate(parameters);
			}
		}
		return _.isUndefined(text) || text === null ? '' : text;
	}

	public interpolation(text: string): TextInterpolation {
		if (_.isString(text)) {
			const textInterpolation = this.getTextInterpolation(text);
			if (textInterpolation) {
				return textInterpolation;
			}
			return new TextInterpolation(new LiteralPrimitive(undefined, undefined, text), this.injector, this.translatePipe);
		}
		return undefined;
	}

	private getTextInterpolation(text: string): TextInterpolation {
		let textInterpolation: TextInterpolation = this._textInterpolations[text];

		if (!textInterpolation) {
			const config = InterpolationConfig.fromArray(['{{', '}}']);
			const ast = this._parser.parseInterpolation(text, 'template', 0, config);

			if (!ast) {
				return null;
			}

			if (ast.ast instanceof Interpolation) {
				textInterpolation = this.buildTextInterpolation(<Interpolation>ast.ast);
			} else {
				throw new Error(`The provided text is not a valid interpolation. Provided type ${ast.ast.constructor?.name}`);
			}
		}

		return textInterpolation;
	}

	private buildTextInterpolation(interpolation: Interpolation): TextInterpolation {
		return new TextInterpolation(interpolation, this.injector, this.translatePipe);
	}

}
